module.exports = __webpack_public_path__ + "img/free_kicks.22855de.png";